import { Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useTemplateCategoriesContext } from '../contexts/TemplateCategoriesContext';
import FormCategory from './FormCategory';

export default function ModalCategory() {
  const { modals, state: { category } } = useTemplateCategoriesContext();

  return (
    <Modal 
      variant="form"
      isOpen={modals.category.isOpen} 
      onClose={modals.category.onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
        { category ? 'Editar categoria' : 'Nova categoria' }
        </ModalHeader>
        <ModalCloseButton />
        <FormCategory category={category} />
      </ModalContent>
    </Modal>
  )
}